export class AdminEnableUserPayload {}